/**
 * 客服联系方式统一读取（canonical 数据源：system_config → GET /config/platform-profile 的 customerService 字段）
 *
 * 全站用户可见入口（Center 客服中心/平台资质、商品详情客服按钮、订单详情"联系我们"）
 * 一律从这里取号，禁止页面自行写死。已并入 publicConfig 单请求缓存（品牌/资质/客服一条 HTTP）；
 * 本文件保留为兼容出口——既有调用方（Center/Detailspage/Order）零改动。
 */
import { fetchPublicConfig } from './publicConfig'

export function fetchCustomerService (force) {
  return fetchPublicConfig(force).then(cfg => cfg.customerService)
}
